import { CountryCode } from '@constants'
import { type CheckoutOrder } from '@hooks-api/types/dataModel/orders'
import { useFormContext, useWatch } from 'react-hook-form'
import { AddressHkReceiver } from './AddressHkReceiver'
import { AddressMoReceiver } from './AddressMoReceiver'
import { AddressTwReceiver } from './AddressTwReceiver'

export function AddressReceiver() {
  const { control } = useFormContext<CheckoutOrder>()
  const countryCode = useWatch({ control, name: 'billing_country' })

  if (countryCode === CountryCode.TW) {
    return <AddressTwReceiver />
  }
  else if (countryCode === CountryCode.HK) {
    return <AddressHkReceiver />
  }
  else if (countryCode === CountryCode.MO) {
    return <AddressMoReceiver />
  }
}
